import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { BrandingConfigurator } from "../components/BrandingConfigurator";

export default function BrandingSettingsPage() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen" style={{ background: "#0b0811" }} data-testid="branding-settings-page">
      <div className="max-w-5xl mx-auto px-6 py-10">
        <button onClick={() => navigate(-1)} className="flex items-center gap-1 text-xs text-slate-400 hover:text-white mb-4">
          <ArrowLeft className="w-3.5 h-3.5" /> Retour
        </button>
        <BrandingConfigurator />
      </div>
    </div>
  );
}
